var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index_div"},[_c('h1',[_vm._v("商户搜索管理系统")]),_c('div',[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.goPage('/HouseInsert')}}},[_vm._v("新增商户")]),_c('el-button',{attrs:{"type":"success"},on:{"click":function($event){return _vm.goPage('/HouseView')}}},[_vm._v("地图搜店")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }